<script>
import i18n from "@/plugins/i18n";
import store from "@/store";
import chroma from "chroma-js";

export default {
	props: {
		value: {
			type: Number,
			default: -1
		},
		steps: {
			type: Array,
			default: () => [],
			required: true
		}
	},
	data() {
		return {
			windowWidth: 0
		};
	},
	computed: {
		locale() {
			return i18n.locale;
		},
		stepperBackgroundColor() {
			return chroma(store.getters.theme.secondaryColor).rgb();
		}
	},
	mounted() {
		this.$nextTick(() => {
			this.windowWidth = window.innerWidth;
			window.addEventListener("resize", this.getWindowWidth);
		});
	},
	beforeDestroy() {
		window.removeEventListener("resize", this.getWindowWidth);
	},
	methods: {
		createStepperSet(createElement, step, index, currentIndex, text) {
			const arr = [];

			const bg = this.stepperBackgroundColor;

			/* Create Divider */
			if (index) {
				const alphaDivider = index <= currentIndex ? 0.65 : 0.25;
				arr.push(
					createElement("div", {
						class: {
							stepper__divider: true
						},
						style: {
							borderColor: `rgba(${bg[0]}, ${bg[1]}, ${bg[2]}, ${alphaDivider})`
						}
					})
				);
			}

			/* Create Step */
			const stepChildren = [
				createElement(
					"span",
					{
						class: { "stepper__step-number": true }
					},
					[text]
				)
			];

			if (index === currentIndex) {
				stepChildren.push(
					createElement(
						"span",
						{
							class: { "stepper__step-label": true }
						},
						[step[this.locale]]
					)
				);
			}

			let alphaStepper;
			if (index === currentIndex) {
				alphaStepper = 1;
			} else if (index < currentIndex) alphaStepper = 0.65;
			else alphaStepper = 0.25;
			arr.push(
				createElement(
					"div",
					{
						class: {
							stepper__step: true
						},
						style: {
							backgroundColor: `rgba(${bg[0]}, ${bg[1]}, ${bg[2]}, ${alphaStepper})`
						}
					},
					stepChildren
				)
			);

			return arr;
		},
		getWindowWidth() {
			this.windowWidth = window.innerWidth;
		}
	},
	render(createElement) {
		const { value, steps } = this;
		const stepElements = [];
		/* Define magic numbers: Stepper positions */
		const current = value - 1;
		const first = 0;
		const second = 1;
		const third = 2;
		const last = steps.length - 1;
		const secondToLast = last - 1;
		const thirdToLast = secondToLast - 1;
		stepElements.push(
			steps.map((step, index) => {
				if (this.windowWidth > 1100) {
					return this.createStepperSet(
						createElement,
						step,
						index,
						current,
						index + 1
					);
				}
				if (
					[first, last, current].indexOf(index) >= 0 ||
					(index === second &&
						[third, first].indexOf(current) >= 0) ||
					(index === third &&
						[second, first].indexOf(current) >= 0) ||
					(index === thirdToLast &&
						[secondToLast, last].indexOf(current) >= 0) ||
					(index === secondToLast &&
						[thirdToLast, last].indexOf(current) >= 0)
				) {
					return this.createStepperSet(
						createElement,
						step,
						index,
						current,
						index + 1
					);
				} else if (index === second || index === secondToLast) {
					return this.createStepperSet(
						createElement,
						step,
						index,
						current,
						"..."
					);
				}
				return undefined;
			})
		);
		return createElement("div", { class: "stepper" }, stepElements);
	}
};
</script>

<style>
.stepper {
	width: 80%;
	padding: 0 20px 0 165px;
	align-self: flex-start;

	display: flex;
	justify-content: space-between;
	align-items: center;
}

@media only screen and (max-width: 767px) {
	.stepper {
		display: none;
	}
}

.stepper__step {
	position: relative;
	width: 34px;
	height: 34px;
	background-color: var(--secondary-color);
	border-radius: 50%;
	flex-shrink: 0;

	display: flex;
	justify-content: center;
	align-items: center;
}

.stepper__step-number {
	font-family: Verdana, sans-serif;
	font-size: 14px;
	color: #fff;
	position: relative;
}

.stepper__divider {
	width: 100%;
	margin: 0 12px;
	border-top: 3px solid #dad9d9;
}

.stepper__step-label {
	position: absolute;
	white-space: nowrap;
	text-align: center;
	font-family: TheSansOsF, sans-serif;
	font-size: 18px;
	font-weight: 600;
	color: var(--secondary-color);
	top: 45px;
	/* IE11 Label fix */
	transform: translateX(50%);
	right: 50%;
}
</style>
